var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMoveEp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "31px",
    viewBox: "0 0 36 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMoveEp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M609.659653,978.020833 L637.926875,978.020833 C639.717778,978.020833 641.169861,976.56875 641.169861,974.777847 L641.169861,957.546458 C641.169861,955.755556 639.717778,954.303472 637.926875,954.303472 L625.148542,954.303472 C624.712917,954.303472 624.325694,954.158264 624.035278,953.867847 L619.340208,949.802014 C618.710972,949.221181 617.984931,948.979167 617.210486,948.979167 L609.659653,948.979167 C607.86875,948.979167 606.416667,950.43125 606.416667,952.222153 L606.416667,974.777847 C606.416667,976.56875 607.86875,978.020833 609.659653,978.020833 Z M607.917153,952.222153 C607.917153,951.254097 608.691597,950.479653 609.659653,950.479653 L617.210486,950.479653 C617.646111,950.479653 618.033333,950.624861 618.32375,950.915278 L623.018819,954.981111 C623.599653,955.513542 624.374097,955.755556 625.148542,955.755556 L637.926875,955.755556 C638.894931,955.755556 639.669375,956.53 639.669375,957.498056 L639.669375,974.729444 C639.669375,975.6975 638.894931,976.471944 637.926875,976.471944 L609.659653,976.471944 C608.691597,976.471944 607.917153,975.6975 607.917153,974.729444 C607.917153,974.777847 607.917153,952.222153 607.917153,952.222153 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Edit-Profile/photos-album-not-mp-mouseover",
    transform: "translate(-606.000000, -948.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icMoveEp",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoveEp);
export default __webpack_public_path__ + "static/media/icMoveEp.224dc4fdcd22246eb80e855f6333e71c.svg";
export { ForwardRef as ReactComponent };